import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import KeyList from './Key/KeyList'
import ValueList from './Value/ValueList'
import { useSelector } from 'react-redux'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import NotFound from '../../NotFound/NotFound'

const ManageConfig = () => {
  const [activeToggle, setActiveToggle] = useState('config_key')
  const { pageAccess } = useSelector((state) => state.user)

  const handleTabClick = (e, tabName) => {
    e.preventDefault()
    setActiveToggle(tabName)
  }

  return checkPageAccess(
    pageAccess,
    allPages?.manageConfig,
    allCrudNames?.read
  ) ? (
    <>
      {checkPageAccess(
        pageAccess,
        allPages?.manageConfig,
        allCrudNames?.read
      ) && (
        <div className='card overflow-hidden'>
          <div className='card-body p-0'>
            <div className='nav-tabs-horizontal nav nav-tabs'>
              <Link
                // onClick={() => setActiveToggle('config_key')}
                onClick={(e) => handleTabClick(e, 'config_key')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'config_key' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Config Key
                  <hr />
                </span>
              </Link>
              <Link
                // onClick={() => setActiveToggle('config_value')}
                onClick={(e) => handleTabClick(e, 'config_value')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'config_value' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Config Value
                  <hr />
                </span>
              </Link>
            </div>

            <div className='tab-content p-3'>
              <div
                id='config_key'
                className={`tab-pane fade ${
                  activeToggle === 'config_key' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'config_key' && <KeyList />}
              </div>

              <div
                id='config_value'
                className={`tab-pane fade ${
                  activeToggle === 'config_value' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'config_value' && <ValueList />}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  ) : (
    <NotFound />
  )
}

export default ManageConfig
